import { render, staticRenderFns } from "./btn-outline-primary-disabled.mpx?vue&type=template&id=ff06f454&isComponent&outputPath=components%2Fbtn-outline-primary-disabled255dc3ea%2Findex"
import script from "./btn-outline-primary-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-primary-disabled255dc3ea%2Findex"
export * from "./btn-outline-primary-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-primary-disabled255dc3ea%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports